<template>
  <v-toolbar flat class="mb-4">
    <v-toolbar-title>
      {{ title }}
      <span></span>
    </v-toolbar-title>
    <v-spacer />
    <div>
      <v-tooltip bottom v-if="permitted('Formula.Create')">
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="accent"
            router
            to="/formula/import"
            v-on="on"
          >
            <v-icon dark>mdi-page-next-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("formula.createImport") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="accent"
            router
            to="/formula"
            v-on="on"
          >
            <v-icon dark>mdi-calculator-variant</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("formula.toolbar") }}</span>
      </v-tooltip>

      <v-tooltip bottom v-if="permitted('Formula.Create')">
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/formula/create"
            v-on="on"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("formula.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "FormulaToolbar",
  props: ["title"],
};
</script>
